import { render } from "./FeatureButton.vue?vue&type=template&id=5cba4a9f&scoped=true"
import script from "./FeatureButton.vue?vue&type=script&lang=js"
export * from "./FeatureButton.vue?vue&type=script&lang=js"

import "./FeatureButton.vue?vue&type=style&index=0&id=5cba4a9f&scoped=true&lang=css"

import exportComponent from "/Users/permartinson/Documents/GitHub/wpcedit/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cba4a9f"]])

export default __exports__